import { logError } from '../utils/logger';

/**
 * Configuración de MercadoPago
 *
 * Public Key: https://www.mercadopago.com.ar/developers/panel/app
 * Tras cambiar .env: detener y volver a ejecutar `npm start` (CRA inyecta REACT_APP_* al arrancar).
 */

const PANEL_MP = 'https://www.mercadopago.com.ar/developers/panel/app';

/** Quita comillas/BOM y caracteres invisibles que rompen /^TEST-/ si quedan delante del valor. */
const normalizePublicKey = (raw) => {
  if (raw == null) return '';
  let s = String(raw).trim();
  if (s === 'undefined' || s === 'null') return '';
  s = s.replace(/^[\uFEFF\u200B-\u200D]+/g, '').replace(/[\uFEFF\u200B-\u200D]+$/g, '');
  if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
    s = s.slice(1, -1).trim();
  }
  return s;
};

/**
 * Public Key real de MP (TEST- o APP_USR-). Usa startsWith: más robusto que /^/ si hubo basura invisible.
 */
const looksLikeRealMercadoPagoPublicKey = (key) => {
  const t = normalizePublicKey(key);
  if (!t) return false;
  const lower = t.toLowerCase();
  if (lower.startsWith('test-') && t.length >= 12) return true;
  if (lower.startsWith('app_usr-') && t.length >= 12) return true;
  return false;
};

export const isMercadoPagoPublicKeyPlaceholder = (key) => {
  const s = normalizePublicKey(key);
  if (!s) return true;
  if (looksLikeRealMercadoPagoPublicKey(s)) return false;

  const lower = s.toLowerCase();
  if (lower.includes('<tu-clave>')) return true;
  if (lower === 'prod-<tu-clave>' || lower === 'test-<tu-clave>') return true;
  if (/<\s*tu[-\s]?clave\s*>/i.test(s)) return true;
  if (lower.includes('reemplaza') && lower.includes('public')) return true;
  return true;
};

export const getMercadoPagoPublicKey = () => {
  const raw = process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY;
  const key = normalizePublicKey(raw);

  if (!key) {
    logError('❌ REACT_APP_MERCADOPAGO_PUBLIC_KEY no está configurada');
    logError(`   En client-react/.env (o .env.local): REACT_APP_MERCADOPAGO_PUBLIC_KEY=TEST-...`);
    logError(`   Luego reinicia por completo: Ctrl+C y npm start (${PANEL_MP})`);
    return null;
  }

  if (isMercadoPagoPublicKeyPlaceholder(key)) {
    logError('❌ REACT_APP_MERCADOPAGO_PUBLIC_KEY no es válida (placeholder o texto de ejemplo).');
    logError(`   Valor leído (primeros 40 caracteres): ${key.slice(0, 40)}${key.length > 40 ? '…' : ''}`);
    logError(`   Si acabas de editar .env, reinicia el servidor de React (npm start).`);
    return null;
  }

  return key;
};

export const isTestMode = () => {
  const key = normalizePublicKey(process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY);
  if (!key) return false;
  if (isMercadoPagoPublicKeyPlaceholder(key)) return false;
  return /^TEST-/i.test(key);
};
